import styled from 'styled-components';

export const DivForm = styled.div`
    
    display: table;
    margin-left:auto;
    margin-right:auto;
    width:70%;
    padding-bottom: 150px;
    max-width:1024px;
    `

export const DivGrid = styled.div`
  display:grid;
  grid-template-columns: auto auto;
  margin-top: 40px;

  @media (max-width: 700px){
    grid-template-columns: auto;
    margin-top:15px;
 }

 `;

 export const GridValues = styled.div`
 display:grid;
 grid-template-columns: auto auto;
 max-width: 500px;
 width: 100%;
 grid-row-gap: 15px;

 
 @media (max-width: 700px){
  grid-template-columns: auto;
  margin-left: 20px;
  margin-top: 15px;
}
`;

 
export const TitleText = styled.div`
  color: #6C5AF4;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  max-width: 250px;
  min-width: 250px;
  width: 100%;

  @media (max-width: 700px){
    min-width: 205px;
 }

 `;
export const ValueText = styled.span`
  color: #212121;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
 `;

 export const MidTitle = styled.span`
  color: #212121;
  text-align: center;
  font-size: 20px;
  font-family: Kanit;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 40px;
  margin-left:auto;
  margin-right:auto;
  display:block;
 `;

 export const DivButton = styled.div`
    @media (max-width: 700px){
      margin-left:auto;
      margin-right:auto;
    }
    .buttonBack {
        font-size: 0.875rem;
        font-weight: 700;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #6C5AF4;
        border-radius: 8px;
        color: #6C5AF4;
        text-transform:none;
        @media (max-width: 700px){
          width: 155px;
          height: 49px;
        }
      }

      .buttonBack:hover {background: #FFFFFF}

      .buttonSend {
        font-size: 0.875rem;
        font-weight: 700;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #6C5AF4;
        border-radius: 8px;
        color: #FFFFFF;
        float:right;
        text-transform:none;
        @media (max-width: 700px){
          width: 155px;
          height: 49px;
        }
      }

      .buttonSend:hover {background: #6C5AF4;}

 `;
 export const DivSuccessSend = styled.div`

  width:80%;
  height:auto;
  display:block;
  margin: 0px auto 80px auto;
  padding-bottom: 80px;

  .title-clickSign{
    color: #212121;
    text-align: center;
    font-family: Kanit;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding-top: 25px;
    width: 80%;
    margin: 0 auto;
  }

  .text-clickSign{
    color: #212121;
    text-align: center;
    font-family: Open Sans;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-top: 25px
  }

  .purpleText-clickSign{
    color: #6C5AF4;
    text-align: center;
    font-family: Kanit;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-top: 25px
  }

  .footer-ClickSign{
    color: #212121;
    text-align: center;
    font-family: Open Sans;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
  }

  .footer-ClickSign a {
    text-decoration:underline;
  }

  .footer-ClickSign a:hover {
    text-decoration:none;
  }

  .imgClickSign{
    background: url('./images/imgClickSign.svg') no-repeat;  
    width: 250px;
    background-position: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 25px
  }

  .imgLogoClickSign{
    background: url('./images/LogoClickSign.svg') no-repeat;  
    width: 250px;
    height: 65px;
    background-position: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .gridFooter-ClickSign{
    display:grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    margin-top: 25px;

    @media (max-width: 700px){
      
    }

    img{
      cursor:pointer;
    }
  }

  .footer2-ClickSign{
    color: #6C5AF4;
    font-family: Open Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor:pointer;
  }

  .span-ClickSign{
    color: #6C5AF4;
    text-align: center;
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration: underline;
    cursor:pointer;
    margin-left:2px;
  }

  .span-ClickSign:hover{
    text-decoration: none;
  }

  `